import { Answer, Filter } from '../typings/filters'

const getSelectedFiltersByValues = (
  selectedFilters: Filter[],
  values: Record<number, Answer[]>
) => {
  return selectedFilters.filter((filter) => {
    const id = filter.variable_id
    const valueList = values[id]
    return (
      valueList !== undefined &&
      !!valueList.find((value) => value.answer_code === filter.answer_code)
    )
  })
}

const getCountPerVariable = (selectedFiltersByValues: Filter[]) => {
  const obj: { [key: number]: number } = {}
  selectedFiltersByValues.forEach((filter) => {
    const id = filter.variable_id
    obj[id] = obj[id] + 1 || 1
  })
  return obj
}

const updateSelectedCriteria = (
  allSelectedCriteria: { filterCriteria: boolean; exceedFiltersLimit: boolean },
  selectedFilters: Filter[]
) => {
  const exceedFiltersLimitCondition = selectedFilters.length > 60
  if (!exceedFiltersLimitCondition) {
    allSelectedCriteria.exceedFiltersLimit = false
  } else {
    allSelectedCriteria.exceedFiltersLimit = true
  }
}

export const useFilterCriteriaCheck = (
  selectedFilters: Filter[],
  values: Record<number, Answer[]>
) => {
  const allSelectedCriteria = { filterCriteria: false, exceedFiltersLimit: false }

  const selectedFiltersByValues = getSelectedFiltersByValues(selectedFilters, values)
  const obj = getCountPerVariable(selectedFiltersByValues)

  for (const key in obj) {
    if (values[key] !== undefined) {
      updateSelectedCriteria(allSelectedCriteria, selectedFilters)
    }
  }

  return { allSelectedCriteria }
}
